import { Suspense } from "react";
import Spin from "antd/es/spin";

export const SuspenseLoader = ({ children }) => {
  return (
    <Suspense fallback={<Spin spinning fullscreen />}>{children}</Suspense>
  );
};
